export const state = {
    account: null,
    loggedIn: null,
    accessToken: null
};
